module.exports = __webpack_public_path__ + "static/media/edit.fb9a04f1.svg";